import { LoginProvider } from './login-provider';
import { SocialUser } from './user';
/**
 * @abstract
 */
export abstract class BaseLoginProvider implements LoginProvider {
constructor() {}
/**
 * @abstract
 * @return {?}
 */
initialize() {}
/**
 * @abstract
 * @return {?}
 */
signIn() {}
/**
 * @abstract
 * @return {?}
 */
signOut() {}
/**
 * @param {?} id
 * @param {?} src
 * @param {?} onload
 * @return {?}
 */
loadScript(id: string, src: string, onload: any): void {
      if (document.getElementById(id)) { return; }

      let /** @type {?} */ signInJS = document.createElement("script");
      signInJS.async = true;
      signInJS.src = src;
      signInJS.onload = onload;
      document.head.appendChild(signInJS);
  }
}
